// Copyright (c) Jupyter Development Team.
// Distributed under the terms of the Modified BSD License.
/**
 * Registry that holds display providers for different source types.
 */
export class DebuggerDisplayRegistry {
    constructor() {
        this._providers = [];
    }
    /**
     * Register a display provider.
     *
     * @param provider source display providder to register.
     */
    register(provider) {
        this._providers.push(provider);
    }
    /**
     * Try all providers. If any returns something more meaningful than `source.path`,
     * use that. Otherwise, fall back to `source.path`.
     */
    getDisplayName(source) {
        var _a;
        const path = (_a = source.path) !== null && _a !== void 0 ? _a : '';
        let index = path;
        for (const provider of this._providers) {
            if (!provider.canHandle(source)) {
                continue;
            }
            const name = provider.getDisplayName(source);
            // If provider returns something different or more descriptive than raw path
            if (name && name !== path) {
                index = name;
            }
        }
        return index;
    }
}
//# sourceMappingURL=displayregistry.js.map